/**
 * Matches API validateRoleDepartmentRequired hardcode and dump department id 1
 * (display name: Main Office).
 */
export const MAIN_OFFICE_DEPARTMENT_ID = 1;

/** Native select / SearchBar optgroup label for non–Main Office departments. */
export const OTHER_DEPARTMENTS_GROUP_LABEL = "Other departments";
